import { attr } from '@ember-data/model';
import ShModel from './sh-model';

const AssignmentBlastTest = ShModel.extend({
  // attributes
  budget: attr('blast-status'),
  confirmation: attr('blast-status'),
  rating: attr('blast-status'),
  summary: attr('blast-status')
});

export default AssignmentBlastTest;
